import { render, staticRenderFns } from "./editConfirm.vue?vue&type=template&id=13295549&scoped=true&"
import script from "./editConfirm.vue?vue&type=script&lang=js&"
export * from "./editConfirm.vue?vue&type=script&lang=js&"
import style0 from "./editConfirm.vue?vue&type=style&index=0&id=13295549&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13295549",
  null
  
)

export default component.exports